//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHoverBg: false,
            carOptions: {
                width: 74,
                height: 180
            },
            cars: [{
                percentageNeeded: 20,
                dropAreaIndex: -1,
                parkingSpaceIndex: -1,
                image: '/images/game/w3d2/car_green_80.png',
            }, {
                percentageNeeded: 50,
                dropAreaIndex: -1,
                parkingSpaceIndex: -1,
                image: '/images/game/w3d2/car_white_50.png',
            }, {
                percentageNeeded: 20,
                dropAreaIndex: -1,
                parkingSpaceIndex: -1,
                image: '/images/game/w3d2/car_blue_80.png',
            }, {
                percentageNeeded: 60,
                dropAreaIndex: -1,
                parkingSpaceIndex: -1,
                image: '/images/game/w3d2/car_yellow_40.png',
            }, {
                percentageNeeded: 40,
                dropAreaIndex: -1,
                parkingSpaceIndex: -1,
                image: '/images/game/w3d2/car_pink_60.png',
            }, {
                percentageNeeded: 20,
                dropAreaIndex: -1,
                parkingSpaceIndex: -1,
                image: '/images/game/w3d2/car2_blue_80.png',
            }, {
                percentageNeeded: 40,
                dropAreaIndex: -1,
                parkingSpaceIndex: -1,
                image: '/images/game/w3d2/car_red_60.png',
            }, {
                percentageNeeded: 30,
                dropAreaIndex: -1,
                parkingSpaceIndex: -1,
                image: '/images/game/w3d2/car_khaki_70.png',
            }, {
                percentageNeeded: 20,
                dropAreaIndex: -1,
                parkingSpaceIndex: -1,
                image: '/images/game/w3d2/car_white_80.png',
            }],
            dropAreas: [
                {
                    xMin: 250,
                    xMax: 545,
                    yMin: 340,
                    yMax: 460,
                    parkingSpaces: []
                },
                {
                    xMin: 560,
                    xMax: 855,
                    yMin: 340,
                    yMax: 460,
                    parkingSpaces: []
                },
                {
                    xMin: 870,
                    xMax: 1165,
                    yMin: 340,
                    yMax: 460,
                    parkingSpaces: []
                }
            ]
        };
    },

    computed: {
        dropAreaPercentages () {
            return this.dropAreas.map((dropArea, dropAreaIndex) => {
                let sum = 100;

                dropArea.parkingSpaces.forEach((parkingSpace, parkingSpaceIndex) => {
                    let car = this.cars.find(car => car.dropAreaIndex === dropAreaIndex && car.parkingSpaceIndex === parkingSpaceIndex);
                    if (car !== undefined) {
                        sum -= car.percentageNeeded;
                    }
                });

                return sum;
            });
        },
        result () {
            let numCorrect = this.dropAreaPercentages.filter(percentage => percentage === 0).length;

            return this.$game.getDragDropResult(numCorrect * 3, (this.dropAreaPercentages.length - numCorrect) * 3);
        }
    },

    created () {
        // setup car positions
        this.cars.forEach((car, index) => {
            this.$set(car, 'x', 320 + (index * 90));
            this.$set(car, 'y', 540);
        });

        // setup parking space positions
        let parkingSpaceWidth = 74;

        this.dropAreas.forEach((dropArea, index) => {
            for (let x = dropArea.xMin; x < dropArea.xMax; x = x + parkingSpaceWidth) {
                dropArea.parkingSpaces.push({
                    xMin: x,
                    xMax: x + parkingSpaceWidth,
                    yMin: dropArea.yMin,
                    yMax: dropArea.yMax
                });
            }
        });
    },

    methods: {
        dragend (car, { x, y }) {
            this.showHoverBg = false;

            car.x = x;
            car.y = y;
            car.parkingSpaceIndex = -1;
            car.dropAreaIndex = this.dropAreas.findIndex((area, index) =>
                x >= area.xMin - this.carOptions.width &&
                x <= area.xMax &&
                y >= area.yMin - this.carOptions.height &&
                y <= area.yMax
            );

            if (car.dropAreaIndex !== -1) {
                this.$nextTick(() => {
                    let dropArea = this.dropAreas[car.dropAreaIndex];

                    car.parkingSpaceIndex = dropArea.parkingSpaces.findIndex((parkingSpace, parkingSpaceIndex) => !this.isParkingSpaceOccupied(car.dropAreaIndex, parkingSpaceIndex));

                    if (car.parkingSpaceIndex !== -1) {
                        let parkingSpace = dropArea.parkingSpaces[car.parkingSpaceIndex];

                        car.x = parkingSpace.xMin;
                        car.y = parkingSpace.yMin;
                    }
                });
            }
        },
        isParkingSpaceOccupied (dropAreaIndex, parkingSpaceIndex) {
            return this.cars.some(car => car.dropAreaIndex === dropAreaIndex && car.parkingSpaceIndex === parkingSpaceIndex);
        }
    }
};
